import axios, { AxiosResponse } from 'axios';

import { buildLiveRampQueryParams } from './buildLiveRampQueryParams';
import { setLiveRamp } from './setLiveRamp';

import { segmentEventTypes } from '../../../components/segment/segmentEventTypes';
import { segmentTrackEvent } from '../../../components/segment/SegmentTrackEvent';
import { APP_LIVE_RAMP_ORIGIN_HEADER, APP_LIVE_RAMP_URL } from '../constants';
import { LiveRampRequestParams, LiveRampResponse } from '../types';

export const fetchLiveRampEnvelope = ({ email, envelope, refresh, settings }: LiveRampRequestParams) => {
  const url = `${APP_LIVE_RAMP_URL}${refresh ? '/refresh' : ''}`;
  const queryParams = buildLiveRampQueryParams({ email, envelope });
  const urlWithQueryParams = `${url}${queryParams}`;

  axios
    .get(urlWithQueryParams, {
      headers: {
        Origin: APP_LIVE_RAMP_ORIGIN_HEADER,
      },
    })
    .then((response: AxiosResponse<LiveRampResponse>) => {
      const data: LiveRampResponse = response.data;
      const status = response.status;

      segmentTrackEvent(segmentEventTypes.LIVE_RAMP_CALL, settings, {
        liveRampData: {
          envelope: data.envelope,
          response: status,
          api_call: urlWithQueryParams,
          refresh: refresh ? '1' : '0',
        },
      });

      return setLiveRamp(data.envelope);
    })
    .catch(() => {
      segmentTrackEvent(segmentEventTypes.LIVE_RAMP_CALL_ERROR, settings, {
        liveRampData: {
          api_call: urlWithQueryParams,
          refresh: refresh ? '1' : '0',
        },
      });
    });
};
